<template>
  <v-container>
    <v-row>
      <v-col md="5" class="d-flex align-center">
        <v-img
          :src="require('@/assets/images/register_image.png')"
          class="ma-8"
          width="400"
        />
      </v-col>
      <v-col md="7" v-if="step === 'resetPass'" class="d-flex align-center">
        <div class="flex-fill">
          <h1 class="text-center">بازیابی کلمه عبور</h1>
          <p class="text-center">
            شماره موبایلی که با آن در سایت ثبت نام کرده اید را وارد نمایید
          </p>
          <v-card outlined class="pa-5">
            <form-alert
              v-if="this.$store.getters.error"
              :message="this.$store.getters.error.message.message"
            />

            <v-form
              v-model="valid"
              @submit.prevent="handleSendActiveCode"
              class="text-center"
            >
              <v-text-field
                outlined
                dense
                name="username"
                v-model="username"
                :rules="usernameRules"
                type="number"
                autocomplete="off"
                label="شماره موبایل"
                required
              />
              <div class="d-flex mt-2">
                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  depressed
                  color="primary"
                  type="submit"
                  class="flex-grow-1"
                >
                  ارسال کد
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </div>
      </v-col>
      <v-col md="7" v-if="step === 'setPassword'" class="d-flex align-center">
        <div class="flex-fill">
          <h1 class="text-center">تایید شماره همراه</h1>
          <p class="text-center">
            کد ارسالی به شماره موبایل خود را وارد نمایید
          </p>
          <v-card outlined class="pa-5">
            <form-alert
              v-if="this.$store.getters.error"
              :message="this.$store.getters.error.message.message"
            />
            <v-form
              v-model="valid"
              @submit.prevent="handleSetPass"
              v-show="step === 'setPassword'"
              class="text-center"
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    name="activeCode"
                    v-model="activeCode"
                    :rules="activeCodeRules"
                    autocomplete="off"
                    label="کد ارسالی"
                    required
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    outlined
                    dense
                    v-model="password"
                    name="password"
                    label="کلمه عبور"
                    :rules="passwordRules"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                    autocomplete="off"
                    counter
                    required
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    outlined
                    dense
                    v-model="confirmPass"
                    label="تکرار کلمه عبور"
                    name="repeat-password"
                    :rules="confirmPassRules.concat(passwordConfirmationRule)"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                    autocomplete="off"
                    counter
                    required
                  />
                </v-col>
              </v-row>
              <div class="d-flex align-center">
                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  depressed
                  color="primary"
                  type="submit"
                  class="flex-grow-1"
                >
                  ارسال
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="counting"
                  @click="resendOtp"
                  depressed
                  outlined
                  color="success"
                  class="mr-2"
                >
                  <countdown
                    v-if="counting"
                    :time="120000"
                    @end="handleCountdownEnd"
                  >
                    <template slot-scope="props">
                      ارسال مجدد {{ props.totalSeconds }}
                    </template>
                  </countdown>
                  <span v-else> ارسال مجدد </span>
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn class="mt-2" router to="/" text> بازگشت </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "forgot-password-component",
  data: () => {
    return {
      loading: false,
      valid: true,
      username: "",
      counting: true,
      step: "resetPass",
      usernameRules: [
        (v) => !!v || "لطفا تلفن همراه خود را وارد نمایید",
        (v) => (v && v.length == 11) || "تلفن همراه را به درستی وارد نمایید"
      ],
      activeCode: "",
      activeCodeRules: [
        (v) => !!v || "کد ارسالی را وارد نمایید",
        (v) =>
          (v && v.length == 6) || "کد ارسالی را با دقت و به درستی وارد نمایید"
      ],
      show1: false,
      show2: false,
      password: "",
      passwordRules: [(v) => !!v || "کلمه عبور خود را وارد نمایید"],
      confirmPass: "",
      confirmPassRules: [(v) => !!v || "تکرار کلمه عبور خود را وارد نمایید"]
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () => this.password === this.confirmPass || "پسور یکسان نیست";
    }
  },
  methods: {
    handleSendActiveCode() {
      this.loading = true;
      this.$store
        .dispatch("forgotPassword", {
          username: this.username
        })
        .then(() => {
          this.step = "setPassword";
          this.loading = false;
        });
    },
    handleSetPass() {
      this.loading = true;
      this.$store.dispatch("resetPassword", {
        username: this.username,
        activeCode: this.activeCode,
        password: this.password
      });
      this.loading = false;
    },
    resendOtp() {
      this.$api
        .post("user/resendOTP", {
          username: this.username
        })
        .then(() => {
          this.counting = true;
        });
    },
    handleCountdownEnd() {
      this.counting = false;
    }
  }
};
</script>
